import {useParams} from "react-router-dom";
import {Tabs} from "antd";
import {PageHeader, ProjectQuota, ProjectToolNav} from "~/components";
import {useCan} from "~/hooks";
import {useGetMySubscriptionQuery} from "~/reduxs/api/subscriptionApiSlice";
import CompetitorList from "../components/CompetitorList";
import CompetitorCompare from "../components/CompetitorCompare";
import CompetitorContentGap from "../components/CompetitorContentGap";
import CompetitorCoverage from "../components/CompetitorCoverage";
import CompetitorLabs from "../components/CompetitorLabs";
import UpgradeCta from "../components/UpgradeCta";

/**
 * Trang tool Phân tích đối thủ của một dự án (`/projects/:id/competitor`).
 *
 *  - Đối thủ        : danh sách đối thủ (trần theo gói) + chấm điểm SEO on-page từng site.
 *  - So sánh SEO    : bảng side-by-side điểm tổng + 7 nhóm tiêu chí, drill-down từng tiêu chí.
 *  - Content Gap    : so trang mình với NHIỀU trang đối thủ — cụm từ thiếu/mỏng + GSC thật.
 *  - Độ phủ từ khoá : ma trận top query GSC × đối thủ nào có nội dung phủ (heuristic, thuần DB).
 *
 * Toàn tool gate cờ gói `can_competitor` (Pro/Max) — gói thiếu → CTA nâng cấp (BE cũng
 * chặn 402 ở mọi mutation). v1 nội bộ: KHÔNG có backlink/DA/traffic ước tính (cần API ngoài).
 */
function CompetitorHome() {

	const {id} = useParams();
	const canCompetitor = useCan('competitor');
	const {data: sub} = useGetMySubscriptionQuery();

	if (!canCompetitor) return <div className="container">Bạn không có quyền sử dụng Phân tích đối thủ.</div>;

	// Cờ gói: chưa tải xong sub thì cứ render tabs (BE tự chặn); tải xong mà gói thiếu → CTA.
	const allowed = !sub || !!sub?.features?.competitor;
	// Gói "Riêng": làm mờ tab Organic (dữ liệu tra cứu nâng cao) — không cho mở.
	const advancedBlocked = !sub?.is_root && sub?.plan?.slug === 'private';

	const items = [
		{key: 'list', label: 'Đối thủ', children: <CompetitorList projectId={id} />},
		{key: 'compare', label: 'So sánh SEO', children: <CompetitorCompare projectId={id} />},
		{key: 'gap', label: 'Content Gap', children: <CompetitorContentGap projectId={id} />},
		{key: 'coverage', label: 'Độ phủ từ khoá', children: <CompetitorCoverage projectId={id} />},
		// Số liệu organic TUYỆT ĐỐI — keyword gap thật + gợi ý đối thủ (gói Riêng: tắt).
		{key: 'labs', label: 'Organic', disabled: advancedBlocked, children: <CompetitorLabs projectId={id} />},
	];

	return (
		<div className="container">
			<ProjectToolNav projectId={id} active="competitor" />

			<PageHeader
				icon="fa-light fa-users-viewfinder"
				title="Phân tích đối thủ"
				subtitle="So sánh điểm SEO on-page, content gap và độ phủ từ khoá với các đối thủ cạnh tranh"
				actions={<ProjectQuota tool="competitor" />}
			/>

			{allowed ? <Tabs items={items} /> : <UpgradeCta />}
		</div>
	);
}

export default CompetitorHome;
